export default {
  GET_CAFES: 'GET_CAFES',
  GET_CAFES_LOADING: 'CAFE_LOADING',
  GET_CAFES_SUCCESS: 'GET_CAFES_SUCCESS',
  GET_CAFES_FAILED: 'GET_CAFES_FAILED',
  GET_CAFES_REJECT: 'GET_CAFES_REJECT',

  GET_AMENITIES: 'GET_AMENITIES',
  GET_AMENITIES_LOADING: 'GET_AMENITIES_LOADING',
  GET_AMENITIES_SUCCESS: 'GET_AMENITIES_SUCCESS',
  GET_AMENITIES_FAILED: 'GET_AMENITIES_FAILED',
  GET_AMENITIES_REJECT: 'GET_AMENITIES_REJECT',

  GET_REGIONS: 'GET_REGIONS',
  GET_REGIONS_LOADING: 'GET_REGIONS_LOADING',
  GET_REGIONS_SUCCESS: 'GET_REGIONS_SUCCESS',
  GET_REGIONS_FAILED: 'GET_REGIONS_FAILED',
  GET_REGIONS_REJECT: 'GET_REGIONS_REJECT',

  GET_SPECIAL_SERVICES: 'GET_SPECIAL_SERVICES',
  GET_SPECIAL_SERVICES_LOADING: 'GET_SPECIAL_SERVICES_LOADING',
  GET_SPECIAL_SERVICES_SUCCESS: 'GET_SPECIAL_SERVICES_SUCCESS',
  GET_SPECIAL_SERVICES_FAILED: 'GET_SPECIAL_SERVICES_FAILED',
  GET_SPECIAL_SERVICES_REJECT: 'GET_SPECIAL_SERVICES_REJECT',

  CLEAR_ADD_OR_EDIT_CAFE_FORM: 'CLEAR_ADD_OR_EDIT_CAFE_FORM',

  INSERT_NEW_CAFE: 'INSERT_NEW_CAFE',
  INSERT_NEW_CAFE_LOADING: 'INSERT_NEW_CAFE_LOADING',
  INSERT_NEW_CAFE_SUCCESS: 'INSERT_NEW_CAFE_SUCCESS',
  INSERT_NEW_CAFE_FAILED: 'INSERT_NEW_CAFE_FAILED',
  INSERT_NEW_CAFE_REJECT: 'INSERT_NEW_CAFE_REJECT',

  GET_CAFE_BY_ID_LOADING: 'GET_CAFE_BY_ID_LOADING',
  GET_CAFE_BY_ID_SUCCESS: 'GET_CAFE_BY_ID_SUCCESS',
  GET_CAFE_BY_ID_FAILURE: 'GET_CAFE_BY_ID_FAILURE',
  GET_CAFE_BY_ID_REJECT: 'GET_CAFE_BY_ID_REJECT',

  UPDATE_CAFE: 'UPDATE_CAFE',
  UPDATE_CAFE_LOADING: 'UPDATE_CAFE_LOADING',
  UPDATE_CAFE_SUCCESS: 'UPDATE_CAFE_SUCCESS',
  UPDATE_CAFE_FAILED: 'UPDATE_CAFE_FAILED',
  UPDATE_CAFE_REJECT: 'UPDATE_CAFE_REJECT',

  FETCH_ALL_CAFE_USERS_SUCCESSFULL: 'FETCH_ALL_CAFE_USERS_SUCCESSFULL',
  FETCH_ALL_CAFE_USERS_FAILURE: 'FETCH_ALL_CAFE_USERS_FAILURE',
  FETCH_ALL_CAFE_USERS_REJECT: 'FETCH_ALL_CAFE_USERS_REJECT',
  FETCH_ALL_CAFE_USERS_LOADING: 'FETCH_ALL_CAFE_USERS_LOADING',

  FETCH_CAFE_SEARCHED_USER_LOADING: 'FETCH_CAFE_SEARCHED_USER_LOADING',
  FETCH_CAFE_SEARCHED_USER_SUCCESSFULL: 'FETCH_CAFE_SEARCHED_USER_SUCCESSFULL',
  FETCH_CAFE_SEARCHED_USER_FAILURE: 'FETCH_CAFE_SEARCHED_USER_FAILURE',
  FETCH_CAFE_SEARCHED_USER_REJECT: 'FETCH_CAFE_SEARCHED_USER_REJECT',

  CHANGE_CAFE_STATUS_LOADING: 'CHANGE_CAFE_STATUS_LOADING',
  CHANGE_CAFE_STATUS_SUCCESS: 'CHANGE_CAFE_STATUS_SUCCESS',
  CHANGE_CAFE_STATUS_FAILED: 'CHANGE_CAFE_STATUS_FAILED',
  CHANGE_CAFE_STATUS_REJECT: 'CHANGE_CAFE_STATUS_REJECT',

  DELETE_CAFE_USER_LOADING: 'DELETE_CAFE_USER_LOADING',
  DELETE_CAFE_USER_SUCCESS: 'DELETE_CAFE_USER_SUCCESS',
  DELETE_CAFE_USER_FAILED: 'DELETE_CAFE_USER_FAILED',
  DELETE_CAFE_USER_REJECT: 'DELETE_CAFE_USER_REJECT',

  ASSIGN_USER_TO_CAFE_LOADING: 'ASSIGN_USER_TO_CAFE_LOADING',
  ASSIGN_USER_TO_CAFE_SUCCESSFULL: 'ASSIGN_USER_TO_CAFE_SUCCESSFULL',
  ASSIGN_USER_TO_CAFE_FAILED: 'ASSIGN_USER_TO_CAFE_FAILED',
  ASSIGN_USER_TO_CAFE_REJECT: 'ASSIGN_USER_TO_CAFE_REJECT',

  FETCH_CAFE_USER_DETAILS_LOADING: 'FETCH_CAFE_USER_DETAILS_LOADING',
  FETCH_CAFE_USER_DETAILS_SUCCESS: 'FETCH_CAFE_USER_DETAILS_SUCCESS',
  FETCH_CAFE_USER_DETAILS_FAILED: 'FETCH_CAFE_USER_DETAILS_FAILED',
  FETCH_CAFE_USER_DETAILS_REJECT: 'FETCH_CAFE_USER_DETAILS_REJECT',

  UPDATE_CAFE_USER_LOADING: 'UPDATE_CAFE_USER_LOADING',
  UPDATE_CAFE_USER_SUCCESS: 'UPDATE_CAFE_USER_SUCCESS',
  UPDATE_CAFE_USER_FAILED: 'UPDATE_CAFE_USER_FAILED',
  UPDATE_CAFE_USER_REJECT: 'UPDATE_CAFE_USER_REJECT',

  GET_CAFE_BY_ID_FOR_ADMIN_LOADING: 'GET_CAFE_BY_ID_FOR_ADMIN_LOADING',
  GET_CAFE_BY_ID_FOR_ADMIN_SUCCESS: 'GET_CAFE_BY_ID_FOR_ADMIN_SUCCESS',
  GET_CAFE_BY_ID_FOR_ADMIN_FAILED: 'GET_CAFE_BY_ID_FOR_ADMIN_FAILED',
  GET_CAFE_BY_ID_FOR_ADMIN_REJECT: 'GET_CAFE_BY_ID_FOR_ADMIN_REJECT',

  UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_LOADING: 'UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_LOADING',
  UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_SUCCESS: 'UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_SUCCESS',
  UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_FAILED: 'UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_FAILED',
  UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_REJECT: 'UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_REJECT',

  FETCH_CAFE_DISCOUNT_BY_ID_LOADING: 'FETCH_CAFE_DISCOUNT_BY_ID_LOADING',
  FETCH_CAFE_DISCOUNT_BY_ID_SUCCESS: 'FETCH_CAFE_DISCOUNT_BY_ID_SUCCESS',
  FETCH_CAFE_DISCOUNT_BY_ID_FAILED: 'FETCH_CAFE_DISCOUNT_BY_ID_FAILED',
  FETCH_CAFE_DISCOUNT_BY_ID_REJECT: 'FETCH_CAFE_DISCOUNT_BY_ID_REJECT',

  GET_ALL_CAFE_NAMES_LOADING: 'GET_ALL_CAFE_NAMES_LOADING',
  GET_ALL_CAFE_NAMES_SUCCESS: 'GET_ALL_CAFE_NAMES_SUCCESS',
  GET_ALL_CAFE_NAMES_FAILED: 'GET_ALL_CAFE_NAMES_FAILED',
  GET_ALL_CAFE_NAMES_REJECT: 'GET_ALL_CAFE_NAMES_REJECT',

  GET_ALL_CAFE_NAMES_FOR_PANEL_LOADING: 'GET_ALL_CAFE_NAMES_FOR_PANEL_LOADING',
  GET_ALL_CAFE_NAMES_FOR_PANEL_SUCCESS: 'GET_ALL_CAFE_NAMES_FOR_PANEL_SUCCESS',
  GET_ALL_CAFE_NAMES_FOR_PANEL_FAILED: 'GET_ALL_CAFE_NAMES_FOR_PANEL_FAILED',
  GET_ALL_CAFE_NAMES_FOR_PANEL_REJECT: 'GET_ALL_CAFE_NAMES_FOR_PANEL_REJECT',

  GET_CAFES_IN_EXCEL: 'GET_CAFES_IN_EXCEL',
  GET_CAFES_IN_EXCEL_LOADING: 'GET_CAFES_IN_EXCEL_LOADING',
  GET_CAFES_IN_EXCEL_SUCCESS: 'GET_CAFES_IN_EXCEL_SUCCESS',
  GET_CAFES_IN_EXCEL_FAILED: 'GET_CAFES_IN_EXCEL_FAILED',
  GET_CAFES_IN_EXCEL_REJECT: 'GET_CAFES_IN_EXCEL_REJECT',

  GET_CAFE_CONTRACT: 'GET_CAFES_CONTRACT',
  GET_CAFES_CONTRACT_LOADING: 'CAFES_CONTRACT_LOADING',
  GET_CAFES_CONTRACT_SUCCESS: 'GET_CAFES_CONTRACT_SUCCESS',
  GET_CAFES_CONTRACT_FAILED: 'GET_CAFES_CONTRACT_FAILED',
  GET_CAFES_CONTRACT_REJECT: 'GET_CAFES_CONTRACT_REJECT',

  GET_CAFES_EXCEL_FILE_LOADING: 'GET_CAFES_EXCEL_FILE_LOADING',
  GET_CAFES_EXCEL_FILE_SUCCESS: 'GET_CAFES_EXCEL_FILE_SUCCESS',
  GET_CAFES_EXCEL_FILE_FAILED: 'GET_CAFES_EXCEL_FILE_FAILED',
  GET_CAFES_EXCEL_FILE_REJECT: 'GET_CAFES_EXCEL_FILE_REJECT'
};
